export const DOI_HINH_ANH = "DOI_HINH";
export const DOI_AO = "DOI_AO";